import React, { Suspense, useState } from "react";
import Header from "../../DefaultLayout/Header";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import Footer from "../../DefaultLayout/Footer";
import Loading from "../../components/Loading";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import { Button, Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { contactUs } from "../../actions/contactUs";
import { connect } from "react-redux";

// css
import "./contactus.css";
import { checkEmailValidation, checkEmptyValidation, checkMobileNumberValidation, checkRequiredValidationWithMinMax } from "../../Helpers/Validation";
import { toast } from "react-toastify";

const ContactUs = (props) => {
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const history = useHistory();
  const {frontLabelsName} = props.label;
  window.scrollTo({ top: 0 });
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNo, setPhoneNo] = useState("")
  const [message, setMessage] = useState("")

  const [errorFirstName, setErrorFirstName] = useState("")
  const [errorLastName, setErrorLastName] = useState("")
  const [errorEmail, setErrorEmail] = useState("")
  const [errorPhoneNo, setErrorPhoneNo] = useState("")
  // const [errorMessage, setErrorMessage] = useState("")

  const HandleSubmit = (e) => {
    e.preventDefault();

    let validationFlag = true;
    setErrorFirstName("")
    setErrorLastName("")
    setErrorEmail("")
    setErrorPhoneNo("")
    // setErrorMessage("")

    let errFirstName = ""
    let errLastname = ""
    let errEmail = ""
    let errPhoneNo = ""
    // let errMessage = ""

    errFirstName = checkEmptyValidation(firstName, "lbl_first_name")
    errLastname = checkEmptyValidation(lastName, "lbl_last_name")
    errEmail = checkEmailValidation(email, "lbl_email")
    errPhoneNo = checkEmptyValidation(phoneNo, "lbl_phone_number");
    // errMessage = checkEmptyValidation(message, "Message")

    if (errFirstName || errLastname || errEmail || errPhoneNo) {

      validationFlag = false;
      setErrorFirstName(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errFirstName)
            .length > 0
          ? frontLabelsName.filter((e) => e.key == errFirstName)[0][
              "value"
            ] || errFirstName
          : errFirstName
        : errFirstName);
      setErrorLastName(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errLastname)
            .length > 0
          ? frontLabelsName.filter((e) => e.key == errLastname)[0][
              "value"
            ] || errLastname
          : errLastname
        : errLastname);
      setErrorEmail(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errEmail)
            .length > 0
          ? frontLabelsName.filter((e) => e.key == errEmail)[0][
              "value"
            ] || errEmail
          : errEmail
        : errEmail);
      setErrorPhoneNo(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == errPhoneNo)
            .length > 0
          ? frontLabelsName.filter((e) => e.key == errPhoneNo)[0][
              "value"
            ] || errPhoneNo
          : errPhoneNo
        : errPhoneNo);
      // setErrorMessage(errMessage);
    } else {
      validationFlag = true;
      setErrorFirstName("");
      setErrorLastName("");
      setErrorEmail("");
      setErrorPhoneNo("");
      // setErrorMessage("");
    }

    if (validationFlag) {
      const data = {
        fname: firstName,
        lname: lastName,
        email: email,
        phone_number: phoneNo,
        message: message
      };

      props.contactUs(data).then((res) => {
        setFirstName("")
        setLastName("")
        setEmail("")
        setPhoneNo("")
        setMessage("")
        toast.success(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == res.data.message)
              .length > 0
            ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                "value"
              ] || res.data.message
            : res.data.message
          : res.data.message);
      }).catch((err) => {
        toast.error(frontLabelsName
    ? frontLabelsName.filter((e) => e.key == err.response.data.message)
        .length > 0
      ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
          "value"
        ] || err.response.data.message
      : err.response.data.message
    : err.response.data.message);
        // setBtnLoading(false);
      }
      )
    }
  }

  return (
    <>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container main-div">
        <div className="row">
          <div
            className=""
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="col-lg-6 col-11">
              <div className="p-5 content-box">
                <div className="contact-text-style">
                  <h3>
                  {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_contact_us")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_contact_us"
                            )[0]["value"] || "lbl_contact_us"
                          : "lbl_contact_us"
                        : "lbl_contact_us"}
                  </h3>
                </div>
                <form>
                  <div className="row pt-4 row_style">
                    <div className="col-lg-6 input-div">
                      <label>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_first_name")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_first_name"
                            )[0]["value"] || "lbl_first_name"
                          : "lbl_first_name"
                        : "lbl_first_name"}
                      </label>
                      <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                      {errorFirstName && (
                        <span className="invalid_span">
                          {errorFirstName}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-6 input-div">
                      <label>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_last_name")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_last_name"
                            )[0]["value"] || "lbl_last_name"
                          : "lbl_last_name"
                        : "lbl_last_name"}
                      </label>
                      <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                      {errorLastName && (
                        <span className="invalid_span">
                          {errorLastName}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row pt-4">
                    <div className="col-12 input-div">
                      <label>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_email")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_email"
                            )[0]["value"] || "lbl_email"
                          : "lbl_email"
                        : "lbl_email"}
                      </label>
                      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                  </div>
                  {errorEmail && (
                    <span className="invalid_span">
                      {errorEmail}
                    </span>
                  )}

                  <div className="row pt-4">
                    <div className="col-12 input-div">
                      <label>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_phone_number")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_phone_number"
                            )[0]["value"] || "lbl_phone_number"
                          : "lbl_phone_number"
                        : "lbl_phone_number"}
                      </label>
                      <input type="number" value={phoneNo} onChange={(e) => setPhoneNo(e.target.value)} />
                    </div>
                  </div>
                  {errorPhoneNo && (
                    <span className="invalid_span">
                      {errorPhoneNo}
                    </span>
                  )}

                  <div className="row pt-4">
                    <div className="col-12 input-div">
                      <label id="msg">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_message")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_message"
                            )[0]["value"] || "lbl_message"
                          : "lbl_message"
                        : "lbl_message"}</label>
                      <textarea
                        rows="3"
                        htmlFor="msg"
                        type="text"
                        className="msg-input-style"
                        value={message}
                        maxLength={2024}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      {/* {errorMessage && (
                        <span className="invalid_span">
                          {errorMessage}
                        </span>
                      )} */}
                    </div>
                  </div>

                  <div className="pt-5 btn-style-contact-main link-ll-color">
                    {/* <Link to="/"> */}
                    <button className="btn-style-contact" onClick={(e) => HandleSubmit(e)}>
                    {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_submit")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_submit"
                            )[0]["value"] || "lbl_submit"
                          : "lbl_submit"
                        : "lbl_submit"}
                    </button>
                    {/* </Link> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense>
        <Footer />
      </Suspense>
    </>
  );
};

// export default ContactUs;
const mapStateToProps = (state)=>({
  label:state.language
})
export default connect(mapStateToProps, {
  contactUs
})(ContactUs);

